export enum WorkflowArea {
    MANDATE_MANAGEMENT = 'MANDATE_MANAGEMENT',
    CLOSING_PROCESS = 'CLOSING_PROCESS',
}
